import React from 'react';
import styles from './Badge.module.css';

/**
 * @component Badge
 * @description 상태 라벨/배지 컴포넌트
 */
function Badge({ children, variant = 'default', size = 'medium', className = '' }) {
  const badgeClasses = [
    styles.badge,
    styles[variant],
    styles[size],
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <span className={badgeClasses}>{children}</span>;
}

export default Badge;
